import { render } from "./ActivitAdmin.vue?vue&type=template&id=dcd7b8ac"
import script from "./ActivitAdmin.vue?vue&type=script&lang=js"
export * from "./ActivitAdmin.vue?vue&type=script&lang=js"

import "./ActivitAdmin.vue?vue&type=style&index=0&id=dcd7b8ac&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__